"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GlobalNavigation = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntl = require("react-intl");
var _constants = require("../../../src/constants");
var _auth = require("../../utils/auth");
var _tmcLinks = require("../../utils/tmcLinks");
var _Navigation = _interopRequireDefault(require("../elements/Navigation"));
var _AutoIntl = _interopRequireDefault(require("../elements/AutoIntl"));
var _AuButton = _interopRequireWildcard(require("../elements/AuButton"));
var _CookieBanner = _interopRequireDefault(require("./CookieBanner"));
var _UserProfile = _interopRequireDefault(require("./UserProfile"));
var _AccountEnvMenu = require("./AccountEnvMenu");
var _AuInput = _interopRequireDefault(require("../elements/AuInput"));
var _context, _context2, _context3;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var alertStyles = {
  "alert_message": "alert_message-module__alert_message___L6_rB",
  "inner": "alert_message-module__inner___y5J3W",
  "inner_title": "alert_message-module__inner_title___n9dmk",
  "title": "alert_message-module__title___V9CM9",
  "new": "alert_message-module__new____YiL7",
  "move-in": "alert_message-module__move-in___b6Hkb",
  "dismissed": "alert_message-module__dismissed___CkzOE",
  "fade-out": "alert_message-module__fade-out___KqHua",
  "alert": "alert_message-module__alert___qgVQv",
  "info": "alert_message-module__info___KWSoA alert_message-module__alert___qgVQv",
  "warning": "alert_message-module__warning___ADTRc alert_message-module__alert___qgVQv",
  "copybtn": "alert_message-module__copybtn___RtrGQ",
  "dismissbtn": "alert_message-module__dismissbtn___SLS0P",
  "error": "alert_message-module__error___kGCXx alert_message-module__alert___qgVQv",
  "message": "alert_message-module__message___Pfjn_",
  "help_container": "alert_message-module__help_container___G_WDl",
  "button_wrapper": "alert_message-module__button_wrapper___vU63V",
  "email": "alert_message-module__email___W2QZr",
  "link": "alert_message-module__link___gh_pC alert_message-module__email___W2QZr",
  "copied": "alert_message-module__copied___RATnK",
  "dismiss_container": "alert_message-module__dismiss_container___H0P5v",
  "dismiss_btn": "alert_message-module__dismiss_btn___plxQJ",
  "hide": "alert_message-module__hide___pTovT"
};
var styles = {
  "container": "global_navigation-module__container___m7pGU",
  "slide": "global_navigation-module__slide___L7iqZ",
  "nav": "global_navigation-module__nav___JU1ZJ",
  "navlink": "global_navigation-module__navlink___PkCix",
  "navopen": "global_navigation-module__navopen___EMiJl global_navigation-module__nav___JU1ZJ",
  "toggle": "global_navigation-module__toggle___EXJsa",
  "close": "global_navigation-module__close___GbhXs",
  "label": "global_navigation-module__label___t_RoK",
  "wrapper": "global_navigation-module__wrapper___rZ6c6",
  "logo": "global_navigation-module__logo___byVuY",
  "usernavlink": "global_navigation-module__usernavlink___zLvMN",
  "acctenvlink": "global_navigation-module__acctenvlink___RPs2y global_navigation-module__usernavlink___zLvMN",
  "confidential": "global_navigation-module__confidential___Qu5aU",
  "confidential_acct_env": "global_navigation-module__confidential_acct_env___HqkyV global_navigation-module__confidential___Qu5aU",
  "userprofile": "global_navigation-module__userprofile___BWTxP",
  "account_env_menu": "global_navigation-module__account_env_menu___yAjIi global_navigation-module__userprofile___BWTxP",
  "icon": "global_navigation-module__icon___G0CdQ",
  "labelvalue": "global_navigation-module__labelvalue___XSTjt",
  "label_value": "global_navigation-module__label_value___shXE7",
  "environment_nav": "global_navigation-module__environment_nav___clOLk",
  "prod": "global_navigation-module__prod___FfwoJ",
  "staging": "global_navigation-module__staging___nWVUC",
  "dev": "global_navigation-module__dev___JL9bh",
  "env_dropdown": "global_navigation-module__env_dropdown____TJJt",
  "env_option": "global_navigation-module__env_option___ur_Qp",
  "update_nav_button": "global_navigation-module__update_nav_button___CyVB2",
  "settings": "global_navigation-module__settings___Do3Bp",
  "settings_container": "global_navigation-module__settings_container___BlTCo",
  "nav_container": "global_navigation-module__nav_container___rzqAx",
  "subnav": "global_navigation-module__subnav___yhCRr",
  "subnav_title": "global_navigation-module__subnav_title___PR4gX",
  "inputs": "global_navigation-module__inputs___nagFP",
  "caption": "global_navigation-module__caption___jTnce",
  "first_input": "global_navigation-module__first_input___rgRpH",
  "message_text": "global_navigation-module__message_text___u8c_K",
  "undo": "global_navigation-module__undo___OnCDV",
  "apply_button": "global_navigation-module__apply_button___KzLyx",
  "hide": "global_navigation-module__hide___vPvdu",
  "banner": "global_navigation-module__banner___KfCxY",
  "message": "global_navigation-module__message___BAjV5",
  "buttons": "global_navigation-module__buttons___gfKKn",
  "dismissbtn": "global_navigation-module__dismissbtn___vgyxr"
};
class GlobalNavigation extends _react.Component {
  static propTypes = {
    navLinks: T.arrayOf(T.object),
    className: T.string,
    navLinkClassName: T.string,
    activeNavLinkClassName: T.string,
    logoLink: T.object,
    breadCrumbs: T.oneOfType([T.bool, T.element]),
    filterBar: T.oneOfType([T.bool, T.element]),
    children: T.oneOfType([T.array, T.element]).isRequired,
    accountId: T.string,
    accountName: T.string,
    showAccountDialog: T.func,
    onUserTokenClick: T.func,
    onUserClientClick: T.func,
    partitions: T.array,
    accounts: (0, _map.default)(_reactImmutableProptypes.default),
    confidentialClient: T.bool,
    partition: T.string,
    showMenu: T.bool,
    showNavBarToggle: T.bool
  };
  static defaultProps = {
    navLinks: [],
    breadCrumbs: false,
    filterBar: false,
    className: '',
    navLinkClassName: '',
    activeNavLinkClassName: '',
    confidentialClient: false,
    showMenu: true,
    showNavBarToggle: true
  };
  constructor(props) {
    super(props);
    const showOriginalNavBar = window.localStorage.getItem('showV1NavBar');
    this.state = {
      open: false,
      showSettingsGear: showOriginalNavBar ? true : false,
      showBanner: false,
      location: window.location.href
    };
  }
  componentDidUpdate() {
    if (this.state.showBanner && this.state.location !== `${window.location.origin}/` && this.state.location !== window.location.href) {
      this.setState({
        showBanner: false
      });
    }
  }
  toggleNav = (0, _bind.default)(_context = this.toggleNav).call(_context, this);
  toggleNav() {
    if (this.state.open) {
      this.closeNav();
    } else {
      this.openNav();
    }
  }
  openNav = (0, _bind.default)(_context2 = this.openNav).call(_context2, this);
  openNav() {
    this.setState({
      open: true
    });
  }
  closeNav = (0, _bind.default)(_context3 = this.closeNav).call(_context3, this);
  closeNav() {
    this.setState({
      open: false
    });
  }
  addLinkClasses(navLinks) {
    const {
      navLinkClassName,
      activeNavLinkClassName
    } = this.props;
    const enhancedNavLinks = [];
    for (let navLink of navLinks) {
      const enhancedNavLink = {
        ...navLink
      };
      enhancedNavLinks.push(enhancedNavLink);
      if (navLink.component) continue;
      if (navLink.onClick) {
        enhancedNavLink.onClick = e => {
          this.closeNav(e);
          navLink.onClick(e);
        };
      } else {
        enhancedNavLink.onClick = this.closeNav;
      }
      enhancedNavLink.className = (0, _classnames.default)(styles.navlink, enhancedNavLink.className, navLinkClassName);
      enhancedNavLink.activeClassName = (0, _classnames.default)(enhancedNavLink.activeClassName, activeNavLinkClassName);
      if (enhancedNavLink.navLinks) {
        enhancedNavLink.navLinks = this.addLinkClasses(enhancedNavLink.navLinks);
      }
    }
    return enhancedNavLinks;
  }
  renderNav() {
    const {
      navLinks
    } = this.props;
    const {
      open
    } = this.state;

    // the wrapper that opens and moves the page should be its own component
    return /*#__PURE__*/_react.default.createElement("div", {
      className: open ? styles.navopen : styles.nav
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.toggle,
      onClick: this.toggleNav
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.close
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.label
    }, open && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "au.globalNavigation.close"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.wrapper
    }, /*#__PURE__*/_react.default.createElement(_Navigation.default, {
      type: "primary",
      navLinks: this.addLinkClasses(navLinks)
    })));
  }
  renderLogo() {
    const {
      logoLink
    } = this.props;
    if (logoLink) {
      return /*#__PURE__*/_react.default.cloneElement(logoLink, {
        className: styles.logo
      });
    } else {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: styles.logo
      });
    }
  }
  closeBanner() {
    this.setState({
      dismissed: true
    }, () => (0, _setTimeout2.default)(() => this.setState({
      showBanner: false
    }), 400));
  }
  onUndoClick() {
    this.closeBanner();
    this.setState({
      showV1NavBar: true,
      showV2NavBar: false
    }, this.props.updateMenuClick());
  }
  onApply() {
    const {
      showBanner
    } = this.state;
    if (showBanner) {
      this.closeBanner();
    }
    this.props.applyBtnClick();
  }
  renderMenuToggle() {
    const {
      showMenuToggle,
      showV1NavBar,
      showV2NavBar
    } = this.props;
    const {
      showSettingsGear
    } = this.state;
    if (showMenuToggle && !showSettingsGear) {
      return /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.updateMenus",
        className: styles.update_nav_button,
        onClick: () => this.setState({
          showSettingsGear: true,
          showBanner: true,
          showV2NavBar: true
        }, this.props.updateMenuClick()),
        tag: "span"
      });
    }
    if (showSettingsGear) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.settings
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.subnav
      }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        className: styles.subnav_title,
        displayId: "au.navigationBar",
        tag: "h3"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.inputs
      }, /*#__PURE__*/_react.default.createElement(_AuInput.default, {
        checked: showV1NavBar,
        onClick: () => this.setState(prevState => ({
          showV1NavBar: !prevState.showV1NavBar,
          showV2NavBar: !prevState.showV2NavBar
        }), this.props.handleVersionToggle()),
        className: styles.first_input,
        captionClassName: styles.caption,
        type: "radio",
        caption: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "au.v1"
        })
      }), /*#__PURE__*/_react.default.createElement(_AuInput.default, {
        checked: showV2NavBar,
        onClick: () => this.setState(prevState => ({
          showV1NavBar: !prevState.showV1NavBar,
          showV2NavBar: !prevState.showV2NavBar
        }), this.props.handleVersionToggle()),
        captionClassName: styles.caption,
        type: "radio",
        caption: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "au.v2"
        })
      })), /*#__PURE__*/_react.default.createElement(_AuButton.default, {
        type: _AuButton.BUTTON_TYPE_TERTIARY,
        size: _AuButton.BUTTON_SIZE_MEDIUM,
        displayId: "au.settings.apply",
        className: styles.apply_button,
        onClick: () => this.onApply()
      }))));
    }
  }
  render() {
    const {
      breadCrumbs,
      filterBar,
      className,
      children,
      showNavBarToggle
    } = this.props;
    const {
      open,
      showBanner,
      dismissed
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className, {
        [styles.slide]: open
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.nav_container
    }, this.renderLogo(), this.renderNav(), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.settings_container
    }, showNavBarToggle && this.renderMenuToggle())), showBanner && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.banner, {
        [alertStyles.new]: !dismissed,
        [alertStyles.dismissed]: dismissed
      })
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.message,
      displayId: "au.navigation.info",
      tag: "div"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.buttons
    }, /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      type: _AuButton.BUTTON_TYPE_TERTIARY,
      size: _AuButton.BUTTON_SIZE_MEDIUM,
      displayId: "au.undo",
      className: styles.undo,
      onClick: () => this.onUndoClick()
    }), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: alertStyles.dismissbtn,
      "data-testid": "dismiss-button",
      onClick: () => this.closeBanner()
    }))), breadCrumbs, filterBar, /*#__PURE__*/_react.default.createElement("main", {
      onClick: this.closeNav
    }, children), /*#__PURE__*/_react.default.createElement(_CookieBanner.default, null));
  }
}
exports.GlobalNavigation = GlobalNavigation;
class ConnectedGlobalNavigation extends _react.Component {
  static propTypes = {
    navLinks: T.arrayOf(T.object),
    accountId: T.string,
    accountName: T.string,
    partition: T.string,
    partitions: T.array,
    accounts: (0, _map.default)(_reactImmutableProptypes.default),
    showMenu: T.bool
  };
  static defaultProps = {
    navLinks: []
  };
  state = {
    showSettingsGear: false
  };
  getEnvironmentDropdown(environment) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.env_dropdown
    }, environment != _constants.DEV_ENV && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.env_option,
      displayId: "au.dev",
      onClick: () => this.openInNewTab(_constants.DEV_LINK)
    }), environment != _constants.STAGING_ENV && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.env_option,
      displayId: "au.staging",
      onClick: () => this.openInNewTab(_constants.STAGING_LINK)
    }), environment != _constants.PROD_ENV && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.env_option,
      displayId: "au.prod",
      onClick: () => this.openInNewTab(_constants.PROD_LINK)
    }));
  }
  getEnvironment() {
    return window.location.origin === _constants.DEV_LINK ? _constants.DEV_ENV : window.location.origin === _constants.STAGING_LINK ? _constants.STAGING_ENV : _constants.PROD_ENV;
  }
  openInNewTab = url => {
    window.open(url, "_blank", "noreferrer");
  };
  render() {
    const {
      partitions,
      confidentialClient,
      showMenu,
      showMenuToggle
    } = this.props;
    const canSwitchPartition = partitions && (0, _keys.default)(partitions).length > 1;
    const navLinks = [...this.props.navLinks];
    const environment = this.getEnvironment();
    const userProfile = /*#__PURE__*/_react.default.createElement(_UserProfile.default, {
      onUserTokenClick: this.props.onUserTokenClick,
      onUserClientClick: this.props.onUserClientClick
    });
    const accountEnvMenu = /*#__PURE__*/_react.default.createElement(_AccountEnvMenu.AccountEnvMenu, {
      accountId: this.props.accountId,
      accountName: this.props.accountName,
      onPartitionChange: this.props.onPartitionChange,
      onAccountChange: this.props.onAccountChange,
      partitions: partitions,
      accounts: this.props.accounts,
      partition: this.props.partition,
      setAccountId: this.props.setAccountId,
      setPartition: this.props.setPartition
    });
    if (showMenu) {
      var _context4;
      navLinks.push({
        labelId: "au.environment",
        labelValues: {
          environment: /*#__PURE__*/_react.default.createElement("span", {
            className: styles.label_value
          }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
            displayId: `au.${environment}`
          }))
        },
        navLinks: [{
          component: this.getEnvironmentDropdown(environment)
        }],
        className: (0, _classnames.default)(styles.environment_nav, {
          [styles.prod]: environment === _constants.PROD_ENV,
          [styles.staging]: environment === _constants.STAGING_ENV,
          [styles.dev]: environment === _constants.DEV_ENV
        })
      }, {
        labelId: canSwitchPartition ? 'au.instance' : 'au.acct',
        labelValues: canSwitchPartition ? {
          instance: /*#__PURE__*/_react.default.createElement("span", {
            className: styles.labelvalue
          }, this.props.partition)
        } : {
          acct: /*#__PURE__*/_react.default.createElement("span", {
            className: styles.labelvalue
          }, this.props.accountName)
        },
        navLinks: [{
          component: accountEnvMenu,
          className: styles.account_env_menu
        }],
        className: (0, _classnames.default)(styles.acctenvlink, {
          [styles.confidential_acct_env]: confidentialClient
        })
      }, {
        labelId: 'au.support',
        className: styles.docs,
        navLinks: (0, _filter.default)(_context4 = (0, _map.default)(_constants.tmcLinkTypes).call(_constants.tmcLinkTypes, linkType => {
          const link = (0, _tmcLinks.getTmcLink)(linkType, window.location.hostname, this.props.partition);
          if (link) {
            return {
              labelId: link.displayId,
              destination: link.destination,
              onClick: link.onClick
            };
          }
          return link;
        })).call(_context4, link => link)
      });
    }
    if (_auth.clientContainer.client) {
      // check for running locally since devserver does not have clientContainer set
      navLinks.push({
        label: _auth.clientContainer.client && (_auth.clientContainer.client.givenName || _auth.clientContainer.client.userName),
        labelId: 'au.globalNavigation.account',
        navLinks: [{
          component: userProfile,
          className: styles.userprofile
        }],
        className: (0, _classnames.default)(styles.usernavlink, {
          [styles.confidential]: confidentialClient
        })
      });
    }
    return /*#__PURE__*/_react.default.createElement(GlobalNavigation, (0, _extends2.default)({}, this.props, {
      navLinks: navLinks
    }));
  }
}
exports.default = ConnectedGlobalNavigation;